// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eiPr","clinicsSelect":"styles_clinicsSelect__3CAmW"};